var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.hasMore
      ? _c(
          "div",
          [
            _c("BrowseLoading", { attrs: { loading: _vm.isLoading } }),
            _vm._v(" "),
            _vm.$slots.retry && !_vm.isLoading && _vm.hasError
              ? _c(
                  "button",
                  {
                    staticClass:
                      "vs-btn btn btn--outline--pink-100 btn--hover--fill--pink-100",
                    on: { click: _vm.retryFn }
                  },
                  [_vm._t("retry")],
                  2
                )
              : _vm._e()
          ],
          1
        )
      : _vm.$slots.scrollEnd
      ? _c(
          "button",
          {
            staticClass:
              "vs-btn btn btn--outline--pink-100 btn--hover--fill--pink-100",
            on: { click: _vm.scrollToTop }
          },
          [_vm._t("scrollEnd")],
          2
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }